<template>
    <div v-if="isValid" class="d-inline-block">
        {{ formattedDateTime }}
    </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
    name: 'LocalDateFromIso',
    components: {},
    props: {
        date: {  // must be ISO formatted date/time - Nov 23 2021 - also allow passing in DateTime Object
            type: [String, DateTime],
            required: true,
        },
        preset: {  // from the Preset options for Luxon -- here: https://moment.github.io/luxon/docs/manual/formatting.html#presets
            // this is preferred method -- takes priority over format string
            type: String,
            required: false,
        },
        formatString: { // Luxon format string, only used if preset is not provided, use something like 'yyyy LLL dd'
            // as specified here:  https://moment.github.io/luxon/docs/manual/formatting.html#toformat
            type: String,
            default: '',
        },
        /* for reference, here are some format string abbreviations:
        'ZZZZ' - abbreviated time zone
        'ZZZZZ' - full time zone name
        'z' - official time zone name (IANA) - America/New_York
        'D' - localized numeric date - 9/14/2020
        'DD' - localized date with abbreviated month
        't' - localized time (12 hour)
        'T' - localized time (24 hour)
        */
    },
    data: function() {
        return {
            
        }
    },
    computed: {
        luxonDateTimeObj: function() {
            return DateTime.isDateTime(this.date) ? this.date : DateTime.fromISO(this.date);
        },
        isValid: function() {
            return this.luxonDateTimeObj ? this.luxonDateTimeObj.isValid : false;
        },
        formattedDateTime: function() {
            if (this.preset) {
                let fullPreset = DateTime[this.preset];
                return this.luxonDateTimeObj.toLocaleString(fullPreset);
            }
            if (this.formatString) {
                return this.luxonDateTimeObj.toFormat(this.formatString);
            }
            // now handle the default case where none of these were provided
            return this.luxonDateTimeObj.toLocaleString(DateTime.DATETIME_FULL);
        },
    },
    methods: {

    }
}
</script>

<style>

</style>